module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-print-active.bcc6a434.svg";